module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('ul', {
    staticClass: "footer__menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v("γενικά για τη χαρακτική")])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "active-class": "active",
      "exact": ""
    }
  }, [_vm._v("εργαστήριο χαρακτικής")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/xilografia",
      "active-class": "active"
    }
  }, [_vm._v("ξυλογραφία")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/oxigrafia",
      "active-class": "active"
    }
  }, [_vm._v("οξυγραφία")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/lithografia",
      "active-class": "active"
    }
  }, [_vm._v("λιθογραφία")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/gallery",
      "active-class": "active"
    }
  }, [_vm._v("γκαλερί")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30e606dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 562
// module chunks = 1